<template>
  <div class="contact-page">
    <div class="container py-5">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="page-header mb-5 fade-in-up">
            <h1 class="display-4 fw-bold mb-4">{{ $t('contact.title') }}</h1>
            <p class="text-muted mb-2">{{ $t('contact.subtitle') }}</p>
            <p class="company-name">{{ $t('company') }}</p>
          </div>
          
          <div class="content-section">
            <div class="row g-4 mb-5 justify-content-center">
              <!-- Email -->
              <div class="col-md-5 fade-in" style="animation-delay: 0.1s;">
                <div class="contact-card text-center">
                  <div class="contact-icon mb-3">
                    <i class="bi bi-envelope"></i>
                  </div>
                  <h5 class="fw-bold mb-2">{{ $t('contact.email') }}</h5>
                  <p class="text-muted mb-3">support@qinfu-cloud.cn</p>
                  <a href="mailto:support@qinfu-cloud.cn" class="btn btn-sm btn-primary">
                    发送邮件
                  </a>
                </div>
              </div>
              
              <!-- WeChat -->
              <div class="col-md-5 fade-in" style="animation-delay: 0.2s;">
                <div class="contact-card text-center">
                  <div class="contact-icon mb-3">
                    <i class="bi bi-wechat"></i>
                  </div>
                  <h5 class="fw-bold mb-2">{{ $t('contact.wechat') }}</h5>
                  <img src="@/assets/gongzhonghao.jpg" alt="微信公众号" class="wechat-qr-contact mb-2">
                  <p class="text-muted small mb-0">{{ $t('contact.scanToFollow') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact'
}
</script>

<style scoped>
.contact-page {
  padding-top: calc(72px + var(--spacing-xl));
  min-height: calc(100vh - 200px);
  background: var(--color-background);
}

.page-header {
  text-align: center;
  margin-bottom: var(--spacing-xl);
}

.page-header h1 {
  font-size: 48px;
  line-height: 1.08349;
  font-weight: 600;
  letter-spacing: -0.003em;
  margin-bottom: var(--spacing-sm);
}

.page-header p {
  font-size: 21px;
  line-height: 1.381;
  color: var(--color-text-secondary);
}

.page-header .company-name {
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: var(--color-text-secondary);
  opacity: 0.85;
}

.contact-card {
  background: var(--color-surface);
  border-radius: var(--radius-lg);
  padding: var(--spacing-lg);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
  height: 100%;
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.contact-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08);
}

.contact-card h5 {
  font-size: 21px;
  line-height: 1.19048;
  font-weight: 600;
  margin-bottom: var(--spacing-xs);
}

.contact-card p {
  font-size: 17px;
  line-height: 1.47059;
  color: var(--color-text-secondary);
}

.contact-icon {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-hover) 100%);
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  color: white;
  margin: 0 auto;
  transition: transform 0.3s ease;
}

.contact-card:hover .contact-icon {
  transform: scale(1.05);
}

.wechat-qr-contact {
  width: 120px;
  height: 120px;
  border-radius: 12px;
  border: 2px solid var(--color-border);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
  margin: 0 auto;
  display: block;
}

.wechat-qr-contact:hover {
  transform: scale(1.1);
}

.btn-primary {
  background: var(--color-primary);
  border: none;
  color: white;
}

.btn-primary:hover {
  background: var(--color-primary-hover);
}

.btn-outline-primary {
  border: 1px solid var(--color-primary);
  color: var(--color-primary);
  background: transparent;
}

.btn-outline-primary:hover {
  background: var(--color-primary);
  color: white;
}

.fade-in-up {
  animation: fadeInUp 0.8s ease-out;
}

.fade-in {
  animation: fadeIn 0.6s ease-out;
  opacity: 0;
  animation-fill-mode: forwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

@media (max-width: 734px) {
  .contact-page {
    padding-top: calc(72px + var(--spacing-lg));
  }
  
  .page-header h1 {
    font-size: 32px;
    line-height: 1.125;
  }
  
  .page-header p {
    font-size: 17px;
  }
  
  .contact-card {
    padding: var(--spacing-md);
  }
}
</style>

